import React from "react";
import { Hero, PageContent } from "../../components";

function PofC() {
  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative flex-col -z-10">
      <Hero title={"Proof of Concept"}>
        The moment dreams take {" "}
        <span className="text-lg font-black text-RougePastel md:text-xl lg:text-2xl">
          their first breath,
        </span>{" "}
        stepping out from imagination to reality.
      </Hero>
      <PageContent>
        {`
To achieve our proof of concept we determined four essential parts that if working separately should work together. Our goal, was therefore, to demonstrate the validity of each part: 
- The ability of both micro-organisms to leave in wastewater 
- The viability of co-culture 
- The heat production 
- The EE2 pollution removal 

## Growth of both microorganisms in wastewater 

The basement of our project is the growth of microorganisms and the use of wastewater. To determine the implementation of the heating device, it was essential to prove that *C. reinhardtii* and *S. meliloti* were able to grow in wastewater.  For this we created a synthetic wastewater media as we were not able to manipulate real wastewater for safety reasons. ([Link to Experiments](https://2023.igem.wiki/ionis-paris/project/experiments))

To avoid cell death linked to media change from an optimize media to a more hostile one, we slowly decreased the percentage of culture media to increase the quantity of wastewater. The following steps were done: 25% of synthetic wastewater then 50% and 75% to finally achieve 100% of wastewater. The concentration of wastewater in optimum media (TAP media for *C. reinhardtii* and LB MC Agar for *S. meliloti* was gradually increased : 25 %, 50%, 75% and finally, 100%. 


The growth of both microorganism was slower in wastewater. However, they were able to stay alive over time. We, therefore, conclude that this part of the proof of concept was validated, we are able to cultivate *S. meliloti* and *C. reinhardtii* in wastewater.

## Viability of co-culture:  

Although it already has been done in literature, we knew that achieving a stable co-culture with no microorganism overgrowing the other one would be a real challenge. Especially with *C. reinhardtii* which has a doubling time twice more elevated than  *S. meliloti*.  

Monitoring microorganism growth is not always an easy task, but it is even worse when two microorganisms have to be controlled in the same culture. To design our proof of concept we got our inspiration from articles. Indeed, we couldn’t just use OD values as for the adaptation, since bacteria and microalgae would absorb at similar wavelength.  Therefore, we used two different counting techniques for *C. reinhardtii* and *S. meliloti* :  

- For the microalgae a sample of co-culture was placed in a Malassez cell and counted under the microscope 

- Bacteria coming from the co-culture sample were counted with plate count method 

<div class="image_frame">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/project/results/results-figure-4.jpeg">
    <p><b><i>C. reinhardtii</i> and <i>S. meliloti</i> growth in co-culture in TAP with a fed-batch like method.</b> Growth was measured every four days and media change. When confluence was reached a sub-culture was done. <i>C. reinhardtii</i> was counted with a Malassez cell and <i>S. meliloti</i> with counting plates.</p>
</div>


After several unsuccessful attempts, we finally reached a stable co-culture in TAP media by starting a culture with 5x105 *C. reinhardtii*/mL. and then let the microalgae grow until maximum cell density was reached (1x107 cells/mL). Every four day, the co culture was centrifugated and media was changed.   

## Heat production:  

In our journey to achieve heat production we successfully managed to transform *C.reinhardtii* and had encouraging results about the correct expression and addressing of our protein. ([Link to Result](https://2023.igem.wiki/ionis-paris/project/results)) 

<div class="image_frame">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/project/results/results-figure-11.jpeg">
    <p>Heat production measurement:</b> temperature was measured every hour and culture isolated in polystyrene box.</p>
</div>


Despite the difficulties encountered to measure heat production we once managed to reach a production of 1.1°C with the mutant *C.reinhardtii* t222+ AOX_3I by adding pyruvate to culture media at a concentration of 5mM.  
The further step would be to reproduce these results and to find a way to improve heat measurement. For this we have the following options in mind:  

- Working in a better isolate environment 
- Increase the volume of culture to lower the impact of the external temperature  
- Supplement the media with reducing agents. 

## EE2 pollution removal:  

For this section, unfortunately we weren’t able to successfully transform *S. meliloti*, therefore we decided to transform *E. coli BL21* to check the correct expression of our plasmid and the efficiency on EE2 molecules.  

        `}
      </PageContent>
    </div>
  );
}

export default PofC;
